"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @description базовый инструмент для записи логов. Внутри себя использует `console`
 *
 * @export
 * @class ConsoleWriter
 * @implements {ITransport}
 */
var ConsoleWriter = /** @class */ (function () {
    function ConsoleWriter() {
    }
    /**
     * @description выводит лог в console, используя `console.log`
     *
     * @param {IMessageEnvelope | IErrorEnvelope} message - лог
     * @memberof ConsoleWriter
     */
    ConsoleWriter.prototype.write = function (message) {
        // tslint:disable-next-line:no-console
        console.log(message);
    };
    return ConsoleWriter;
}());
exports.ConsoleWriter = ConsoleWriter;
//# sourceMappingURL=consoleWriter.js.map